"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioStatementType = void 0;
var StudioStatementType;
(function (StudioStatementType) {
    StudioStatementType["BlockNote"] = "BlockNote";
})(StudioStatementType = exports.StudioStatementType || (exports.StudioStatementType = {}));
